import { render, staticRenderFns } from "./SubmitFooter.vue?vue&type=template&id=0b70eb48&scoped=true&"
import script from "./SubmitFooter.vue?vue&type=script&lang=js&"
export * from "./SubmitFooter.vue?vue&type=script&lang=js&"
import style0 from "./SubmitFooter.vue?vue&type=style&index=0&id=0b70eb48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70eb48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
